// import React from "react";
import { ProgressWrapper } from "screens/courses/progress/Progress";
import { GetLayout } from "types/page";


export const progressLayout: GetLayout = (child) => (
  <ProgressWrapper>
    {child}
  </ProgressWrapper>
)

